export default __webpack_public_path__ + "static/media/Group167@2x.791467aa.png";